module.exports = __webpack_public_path__ + "img/landing_box28.15422388.jpg";